import React from 'react';
import './ListItem.scss';
import {useSelector} from "react-redux";

const selector = state => {
    const { language } = state;
    return {
        t: language.translator
    };
};

const ListItem = props => {
    const {
        item,
        columnsSources,
        columnsWidths,
        actionButtons,
        selectMethod,
        editMethod,
        deleteMethod,
        booleanColumns,
        dateColumns,
        dateAndTimeColumns,
        selected,
        customButtonText,
        customButtonMethod,
        highlight
    } = props;
    const { t } = useSelector(selector);

    const checkFieldType = index => {
        if(dateColumns && dateColumns.includes(index + 1) && item[columnsSources[index]]) {
            return item[columnsSources[index]].split('T').shift();
        }

        if(dateAndTimeColumns && dateAndTimeColumns.includes(index + 1) && item[columnsSources[index]]) {
            return item[columnsSources[index]].split('T').shift() + " " + item[columnsSources[index]].split('T').pop().slice(0,8);
        }

        if(booleanColumns && booleanColumns.includes(index + 1)) {
            if(item[columnsSources[index]]) {
                return <span className="material-icons iconTrue">check</span>
            } else {
                return <span className="material-icons iconFalse">close</span>
            }
        }

        return item[columnsSources[index]]
    };


  const dayInMilliseconds = 1000 * 60 * 60 * 24;
  const highlighted = highlight && !!dateAndTimeColumns && dateAndTimeColumns.length
      ? Math.round((new Date() - new Date(item[columnsSources[dateAndTimeColumns[0] - 1]])) / dayInMilliseconds) > 7
      : false;

    return (
        <li className={`
              ListItem
              ${selectMethod ? 'ListItem--selectable' : ''} 
              ${selected ? 'ListItem--selected' : ''}
              ${highlighted ? 'ListItem--highlighted' : ''}
            `}

            onClick={selectMethod ? () => selectMethod(item.id) : null}
        >
            {columnsSources.map((data, index) => (
                <div
                    key={index}
                    className='listItemCell'
                    style={{width: actionButtons
                            ? `calc(${columnsWidths[index]} - ${(!editMethod || !deleteMethod) && !customButtonText && !customButtonMethod 
                                ? 50 / columnsWidths.length 
                                : 145 / columnsWidths.length
                            }px)`
                            : columnsWidths[index]
                    }}
                >
                    {checkFieldType(index)}
                </div>
            ))}
            {actionButtons &&
                <div
                    className={(!editMethod || !deleteMethod) && !customButtonText && !customButtonMethod
                        ? 'actionButtons actionButtons--single'
                        : 'actionButtons'
                    }
                >
                    {editMethod ?
                        <div className='actionButtonWrapper'>
                            <button className='actionButton' onClick={() => editMethod(item.id)}>
                                <span className='material-icons actionButtonIcon'>
                                    edit
                                </span>
                            </button>
                        </div>
                        : null
                    }
                    {deleteMethod ?
                        <div className='actionButtonWrapper'>
                            <button className='actionButton actionButton--delete' onClick={() => deleteMethod(item.id)}>
                                <span className='material-icons actionButtonIcon'>
                                    delete
                                </span>
                            </button>
                        </div>
                        : null
                    }
                    {customButtonText && customButtonMethod ?
                        <div className='actionButtonWrapper actionButtonWrapper--custom'>
                            <button className='actionButton actionButton--custom' onClick={() => customButtonMethod(item.id)}>
                                {t.gettext(customButtonText)}
                            </button>
                        </div>
                        : null
                    }
                </div>
            }
        </li>
    );
};

export default ListItem;
